<template>
  <div class="main-container row">
    <div class="col-4">
      <div class="chart-box mb-4">
        <h4>تعداد کل نیروی انسانی، برون سپار و مستقیم در پایان شش ماهه سال 1403 (نفر)</h4>
        <BarChart :data="manpowerTotalNumberData" :options="manpowerTotalNumberOptions" chart-style="height: 14.75vw"/>
      </div>
      <div class="chart-box">
        <h4>سرانه ناخالص کل هزینه های نیروی انسانی (میلیون تومان)</h4>
        <BarChart :data="manpowerPerCapitaGrossData" :options="manpowerPerCapitaGrossOptions" chart-style="height: 14.75vw"/>
      </div>
    </div>

    <div class="col-4">
      <div class="chart-box">
        <h4>تعداد نیروهای مستقیم و غیرمستقیم</h4>
        <BarChart :data="directIndirectWorkforceData" :options="directIndirectWorkforceOptions" chart-style="height: 42.3vw"/>
      </div>
    </div>

    <div class="col-4">
      <div class="chart-box mb-4">
        <h4>مطالبات، تعهدات و تسهیالت بانکی (همت)</h4>
        <BarChart :data="bankingClaimsData" :options="bankingClaimsOptions"/>
      </div>
      <div class="table-container mb-4">
        <h4>جدول اطلاعات مالی</h4>
        <DataTable
            :headers="financialTableData.headers"
            :rows="financialTableData.rows"/>
      </div>
      <div class="table-container">
        <h4>جدول اطلاعات بدهی و اختلاف بیمه‌ای</h4>
        <DataTable
            :headers="debtInsuranceTableData.headers"
            :rows="debtInsuranceTableData.rows"/>
      </div>
    </div>
  </div>
</template>

<script>
import ChartHorizontalBar from '@/components/PerformanceManagement/EconomicOperationReport/LineChart.vue'
import DataTable from '@/components/PerformanceManagement/EconomicOperationReport/DataTable.vue'
import BarChart from "@/components/PerformanceManagement/EconomicOperationReport/BarChart.vue";

export default {
  components: {
    BarChart,
    ChartHorizontalBar,
    DataTable
  },
  data() {
    return {
      manpowerTotalNumberData: {
        labels: ['تعداد نیروهای مستقیم', 'تعداد نیروهای برون سپار', 'تعداد نیروهای مستقیم'],
        datasets: [
          {
            backgroundColor: ['#007bff', '#28a745', '#be3434'],
            data: [7069, 3644, 3425]
          },
        ]
      },
      manpowerTotalNumberOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {display: false},
        }
      },

      manpowerPerCapitaGrossData: {
        labels: ['سرانه کل نیروها', 'سرانه نیروهای برون سپار', 'سرانه نیروهای مستقیم'],
        datasets: [
          {
            backgroundColor: ['#007bff', '#28a745', '#be3434'],
            data: [53, 46.9, 59.6]
          },
        ]
      },
      manpowerPerCapitaGrossOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {display: false},
        }
      },

      directIndirectWorkforceData: {
        labels: ['سرانه سود قبل از کسر مالیات', 'سرانه فروش'],
        datasets: [
          {
            backgroundColor: ['#ffc107', '#17a2b8'],
            data: [7069, 3624]
          },
        ]
      },
      directIndirectWorkforceOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {display: false},
        }
      },

      bankingClaimsData: {
        labels: ['مطالبات', 'تعهدات', 'تسهیالت بانکی کل'],
        datasets: [
          {
            backgroundColor: ['#007bff', '#28a745', '#be3434'],
            data: [13.9, 37.5, 15.9]
          },
        ]
      },
      bankingClaimsOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {display: false},
        }
      },

      financialTableData: {
        headers: ['عنوان', 'مبلغ'],
        rows: [
          ['مانده تسهیالت بانکی (همت)', '15.9'],
          ['مانده تسهیالت ریالی (همت)', '6.5'],
          ['مانده تسهیالت ارزی (میلیون دلار)', '198'],
          ['هزینه های مالی (همت)', '0.96'],
        ]
      },
      debtInsuranceTableData: {
        headers: ['عنوان', 'مبلغ (میلیارد تومان)'],
        rows: [
          ['بدهی و اختلاف مالیاتی', '1189'],
          ['بدهی و اختلاف بیمه‌ای', '29']
        ]
      }
    }
  }
}
</script>

<style scoped>
.main-container {
  direction: rtl;
  padding: 1.5vw;
  background-color: #f0f2f5;
  box-sizing: border-box;
  position: relative;
}

.main-container > div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.chart-box, .table-container {
  background-color: white;
  padding: 1.5vw;
  border-radius: .5vw;
  box-shadow: 0 0 .5vw rgba(0, 0, 0, 0.1);
}

.chart-box h4, .table-container h4 {
  font-size: .9vw !important;
  margin-bottom: .6vw;
  text-align: center;
  color: #343a40;
}
</style>
